import React, { useMemo, useState } from "react";

const serif = "font-['Libre_Caslon_Display',Georgia,serif]";
const shell = "mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]";

const DEFAULT_PUBLICATIONS = [
    {
        category: "Research Papers",
        folder: "Research Paper",
        title: "Morphological and Biochemical Characterization of Chironji Populations from Central India for Biodiversity Conservation",
        authors: "Ankur Dahayat, Naseer Mohammad, Raj Singh Yadav and Poonam Verma",
        source: "Agroforestry Systems · Volume 100, Article 154",
        year: "2026",
        doi: "10.1007/s10457-026-01531-6",
        file: "Agroforestry-Research Paper.pdf",
        description: "A biodiversity-focused assessment of morphological and biochemical variation across 120 Chironji accessions from central India.",
    },
    {
        category: "Research Papers",
        folder: "Research Paper",
        title: "Integrative Approaches to Heavy Metal Removal Using Fungal Consortia: Trends, Techniques, and Challenges",
        authors: "Poonam Verma, Madhavi Tiwari, Jyotsana Mishra, Varsha Chandrakar and Prakashchand Sahu",
        source: "Industrial Biotechnology · Mary Ann Liebert, A Part of Sage",
        year: "2026",
        doi: "10.1177/15509087261451131",
        file: "Resaerch Paper verma-et-al-2026-integrative-approaches-to-heavy-metal-.pdf",
        description: "A review of sustainable fungal-consortia strategies for heavy-metal remediation across contaminated environments.",
    },
    {
        category: "Research Papers",
        folder: "Research Paper",
        title: "Seasonal Variation in the Biochemical Composition of Seaweeds from Chilika Lagoon, Odisha, India",
        authors: "Snehalata Das, Jyotsana Mishra, Chetna Rahangdale, Bhagyashree Deshpande, Poonam Verma, Prashant Mundeja and Raj Singh",
        source: "Annals of Biology · 42(2), 192–198",
        year: "2026",
        file: "Research Paper 3. 192-198.pdf",
        description: "A seasonal analysis of biochemical and mineral composition in two macroalgae species collected from Chilika Lagoon.",
    },
    {
        category: "Research Papers",
        folder: "Research Paper",
        title: "Comparative Analysis of Luminescence Efficiency in Rare-Earth-Doped Phosphors",
        authors: "Hema Sahu, Rekha Sahu, N. Pavan Kumar, Poonam Verma, Vikas Dubey and N. Kumar Swamy",
        source: "Journal of Radiation and Nuclear Applications · 11(1), 111–118",
        year: "2026",
        doi: "10.18576/jrna/110113",
        file: "Research Paper BIOMEDICAL-IMAGE-SEGMENTATION-OF-HEART-DISEASE-USING-U-NET-A-COMPREHENSIVE-REVIEW.pdf",
        description: "A literature and experimental review of rare-earth-doped phosphors for advanced photonic and optoelectronic applications.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "Research Methodology",
        authors: "Dr. Poonam Verma and Prof. (Dr.) N. Kumar Swamy",
        source: "English edition · ISBN 978-93-49527-69-0",
        year: "2026",
        file: "Poonam Verma research methedology english final resized.pdf",
        description: "A structured academic guide to research design, scholarly methods and evidence-led investigation.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "Research Methodology — Hindi Edition",
        authors: "Dr. Poonam Verma and Prof. (Dr.) N. Kumar Swamy",
        source: "Vashisthya Publications",
        year: "2026",
        file: "Poonam Verma Research Methodology.pdf",
        description: "A Hindi-language edition developed to make research concepts and academic methodology more accessible.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "Microbiology: A Comprehensive Objective Guide",
        authors: "Dr. Poonam Verma, Dr. Varsha Chandrakar, Dr. Jyotsana Mishra and Dr. Priyanshu Sao",
        source: "SR Edu Publications",
        year: "2026",
        file: "Poonam Verma Microbiology A comprehensive objective guide.pdf",
        description: "An objective-format guide supporting systematic study and assessment across major microbiology themes.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "The Science of Biology for Undergraduate",
        authors: "Dr. Poonam Verma and Ankur Dahayat",
        source: "Doors Publication",
        year: "2026",
        file: "Poonam Verma.pdf",
        description: "A foundational undergraduate resource connecting core biological principles with contemporary scientific understanding.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "Fundamentals of Zoology: Amphibia & Reptile",
        authors: "Madhumanti, Sheena Farheen Khan, Supriyo Acharya and Laxmikant",
        source: "DeepScience",
        year: "2026",
        file: "Laxmikant Book Fundamentals of Zoology.pdf",
        description: "A focused zoology reference addressing the biology and classification of amphibians and reptiles.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "Beyond Boundaries: Exploring Indo-English Literature",
        authors: "Dr. Padmalochan Rout",
        source: "Monica Bhandari Books",
        year: "2026",
        file: "Padmalochan Raut Book Publication.jpeg",
        description: "A scholarly exploration of Indo-English literature, language, culture and literary expression.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "Smart Learning: The Power of AI in Modern Education",
        authors: "Editors: Dr. Amitava Biswas, Dr. Rajeev Gandhi S, Dr. N. Kumar Swamy and Dr. Sunil Kumar Sahu",
        source: "Edited volume",
        year: "2026",
        file: "Sunil and N K Swamy Book Smart education.jpeg",
        description: "An edited work examining how artificial intelligence is reshaping teaching, learning and modern education.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "Emerging Trends in Applied Mathematics and Computational Science",
        authors: "Editors: Dr. Subhashish Biswas and Dr. Sunil Kumar Sahu",
        source: "Chyren Publication",
        year: "2026",
        file: "Sunil Book Chyren.pdf",
        description: "An edited collection on contemporary developments in applied mathematics, computation and data-driven research.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "Green Solutions: New Ideas in Biodiversity, Materials, Technology and Computing",
        authors: "Editors: Pavan Kumar Naini, Poonam Verma, Sunil Kumar Sahu and Nitta Kumar Swamy",
        source: "DeepScience",
        year: "2026",
        file: "Sunil Poonam NK Swamy- Book.pdf",
        description: "A multidisciplinary edited volume connecting biodiversity and sustainable materials with technology and computing.",
    },
    {
        category: "Books",
        folder: "Book Publication",
        title: "Advanced Mathematical Modeling and Simulation in Engineering and Applied Sciences",
        authors: "Editors: Sunil Kumar Sahu, Ghamendra Kumar Sahu and Himanshu Tiwari",
        source: "DeepScience",
        year: "2026",
        file: "sunil full book- First page.pdf",
        description: "An edited volume on mathematical models and simulation methods for engineering and applied-science problems.",
    },
    {
        category: "Patents",
        folder: "Patent",
        title: "Device for Identifying Ligand Binding Sites on Proteins",
        authors: "Dr. Poonam Verma and co-designers",
        source: "Registered Design No. 490609-001 · Class 24-02",
        year: "2026",
        file: "Poonam Verma Patent.pdf",
        description: "A registered design for a device intended to support identification of ligand-binding sites on proteins.",
    },
    {
        category: "Awards",
        folder: "Award",
        title: "Young Researcher Award — M. Visvesvaraya Prize 2026",
        authors: "Dr. Sunil Kumar Sahu",
        source: "Institute of Researchers",
        year: "2026",
        file: "YRA260401_Certificate_Dr. SUNIL KUMAR SAHU.jpg.jpeg",
        description: "Recognition for professional and research achievements in Mathematics, awarded on 15 June 2026.",
    },
];

const categories = ["All", "Research Papers", "Books", "Patents", "Awards"];

function ArrowIcon({ className = "h-5 w-5" }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className} aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-5-5 5 5-5 5" />
        </svg>
    );
}

const publicationHref = (publication, fileBasePath) => {
    if (publication.href) return publication.href;
    if (!fileBasePath || !publication.file) return "#";
    return `${fileBasePath.replace(/\/$/, "")}/${encodeURIComponent(publication.folder)}/${encodeURIComponent(publication.file)}`;
};

export default function FacultyPublicationsSection({
    publications = DEFAULT_PUBLICATIONS,
    fileBasePath = "/faculty-publications/2026",
}) {
    const [category, setCategory] = useState("All");
    const [selected, setSelected] = useState(0);

    const visible = useMemo(
        () => category === "All" ? publications : publications.filter((item) => item.category === category),
        [category, publications]
    );
    const active = visible[Math.min(selected, Math.max(visible.length - 1, 0))];

    const chooseCategory = (value) => {
        setCategory(value);
        setSelected(0);
    };

    return (
        <section className="relative isolate overflow-hidden bg-[#8B1E3F] py-20 text-white sm:py-24 lg:py-28" aria-labelledby="faculty-publications-heading">
            <div className="pointer-events-none absolute inset-0 -z-10" aria-hidden="true">
                <div className="absolute -right-52 -top-52 h-[620px] w-[620px] rounded-full border border-[#D5AD57]/20" />
                <div className="absolute -right-28 -top-28 h-[420px] w-[420px] rounded-full border border-white/10" />
                <div className="absolute inset-0 opacity-[0.06] [background-image:linear-gradient(white_1px,transparent_1px),linear-gradient(90deg,white_1px,transparent_1px)] [background-size:52px_52px] [mask-image:linear-gradient(to_bottom,black,transparent_70%)]" />
            </div>

            <div className={shell}>
                <header className="grid gap-9 border-b border-white/20 pb-10 lg:grid-cols-[1.15fr_.55fr] lg:items-end lg:gap-20">
                    <div>
                        <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                            <span className="h-px w-12 bg-current" />
                            Faculty scholarship · 2026
                        </div>
                        <h2 id="faculty-publications-heading" className={`${serif} mt-6 max-w-5xl text-[clamp(44px,5.5vw,76px)] font-normal leading-[1.03] tracking-[-0.045em]`}>
                            Research that advances
                            <em className="font-normal text-[#D5AD57]"> knowledge and practice.</em>
                        </h2>
                    </div>
                    <p className="border-l border-white/20 pl-7 text-base leading-8 text-white/70 max-lg:border-l-0 max-lg:border-t max-lg:pt-7">
                        Explore faculty books, peer-reviewed research, registered innovation and academic recognition represented in the ISBM Publication 2026 archive.
                    </p>
                </header>

                <div className="mt-10 grid gap-px overflow-hidden border border-white/20 bg-white/20 sm:grid-cols-2 lg:grid-cols-4">
                    {[
                        [publications.length, "Archive records"],
                        [publications.filter((item) => item.category === "Books").length, "Books & volumes"],
                        [publications.filter((item) => item.category === "Research Papers").length, "Research papers"],
                        [publications.filter((item) => ["Patents", "Awards"].includes(item.category)).length, "Innovation & recognition"],
                    ].map(([value, label]) => (
                        <div key={label} className="bg-[#8B1E3F] px-6 py-7">
                            <strong className={`${serif} text-4xl font-normal text-[#D5AD57]`}>{String(value).padStart(2, "0")}</strong>
                            <span className="ml-3 text-sm font-bold uppercase tracking-[0.1em] text-white/65">{label}</span>
                        </div>
                    ))}
                </div>

                <div className="mt-10 flex gap-2 overflow-x-auto border-b-2 border-[#D5AD57]" role="tablist" aria-label="Filter faculty publications">
                    {categories.map((item) => {
                        const count = item === "All" ? publications.length : publications.filter((publication) => publication.category === item).length;
                        return (
                            <button
                                key={item}
                                type="button"
                                role="tab"
                                aria-selected={category === item}
                                onClick={() => chooseCategory(item)}
                                className={`min-h-14 shrink-0 border-x border-t px-5 text-sm font-bold transition ${category === item ? "border-[#D5AD57] bg-[#D5AD57] text-[#071A2F]" : "border-white/20 bg-white/[0.06] text-white hover:bg-white/10"}`}
                            >
                                {item}<span className={`ml-3 ${category === item ? "text-[#8B1E3F]" : "text-[#D5AD57]"}`}>{count}</span>
                            </button>
                        );
                    })}
                </div>

                {active && (
                    <div className="grid overflow-hidden border-x border-b border-white/20 bg-[#F7F2E8] text-[#132337] lg:grid-cols-[.82fr_1.18fr]">
                        <div className="max-h-[700px] custom-scroll overflow-y-auto border-b border-[#071A2F]/15 lg:border-b-0 lg:border-r">
                            {visible.map((publication, index) => (
                                <button
                                    key={`${publication.category}-${publication.title}`}
                                    type="button"
                                    onClick={() => setSelected(index)}
                                    className={`group grid min-h-[118px] w-full grid-cols-[48px_1fr_auto] items-center gap-4 border-b border-[#071A2F]/12 px-5 py-5 text-left transition ${selected === index ? "bg-[#071A2F] text-white" : "bg-[#F7F2E8] text-[#071A2F] hover:bg-white"}`}
                                >
                                    <span className={`grid h-11 w-11 place-items-center rounded-full border text-sm font-bold ${selected === index ? "border-[#D5AD57] bg-[#D5AD57] text-[#071A2F]" : "border-[#8B1E3F]/20 text-[#8B1E3F]"}`}>{String(index + 1).padStart(2, "0")}</span>
                                    <span>
                                        <small className={`block text-sm font-bold uppercase tracking-[0.1em] ${selected === index ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}>{publication.category}</small>
                                        <strong className={`${serif} mt-2 block text-xl font-normal leading-6`}>{publication.title}</strong>
                                    </span>
                                    <ArrowIcon className={`h-4 w-4 transition group-hover:translate-x-1 ${selected === index ? "text-[#D5AD57]" : "text-[#A77B2D]"}`} />
                                </button>
                            ))}
                        </div>

                        <article className="relative min-h-[650px] overflow-hidden bg-white p-7 sm:p-10 lg:p-12">
                            <span className={`${serif} pointer-events-none absolute -right-5 -top-10 text-[170px] leading-none text-[#8B1E3F]/[0.045]`} aria-hidden="true">{String(selected + 1).padStart(2, "0")}</span>
                            <div className="relative flex h-full flex-col">
                                <div className="flex flex-wrap items-center justify-between gap-4">
                                    <span className="rounded-full bg-[#F4E8EC] px-4 py-2 text-sm font-bold uppercase tracking-[0.11em] text-[#8B1E3F]">{active.category}</span>
                                    <span className="text-sm font-bold text-[#A77B2D]">Publication year · {active.year}</span>
                                </div>
                                <h3 className={`${serif} mt-10 max-w-4xl text-[clamp(36px,4.6vw,62px)] font-normal leading-[1.07] tracking-[-0.035em] text-[#071A2F]`}>{active.title}</h3>
                                <p className="mt-6 max-w-3xl text-base font-semibold leading-8 text-[#8B1E3F]">{active.authors}</p>
                                <p className="mt-5 max-w-3xl text-base leading-8 text-[#65717D]">{active.description}</p>

                                <dl className="mt-9 grid border-t border-[#071A2F]/15 sm:grid-cols-2">
                                    <div className="border-b border-[#071A2F]/15 py-6 sm:border-r sm:pr-6">
                                        <dt className="text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">Publication source</dt>
                                        <dd className="mt-3 text-base font-semibold leading-7 text-[#071A2F]">{active.source}</dd>
                                    </div>
                                    <div className="border-b border-[#071A2F]/15 py-6 sm:pl-6">
                                        <dt className="text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">Reference</dt>
                                        <dd className="mt-3 text-base font-semibold leading-7 text-[#071A2F]">{active.doi ? `DOI ${active.doi}` : "ISBM Publication Archive 2026"}</dd>
                                    </div>
                                </dl>

                                <div className="mt-auto flex flex-wrap items-center gap-5 pt-9">
                                    <a href={publicationHref(active, fileBasePath)} target="_blank" rel="noreferrer" className="inline-flex min-h-14 items-center gap-6 bg-[#8B1E3F] px-7 text-sm font-bold uppercase tracking-[0.08em] text-white transition hover:-translate-y-1 hover:bg-[#071A2F]">
                                        View publication <span aria-hidden="true">↗</span>
                                    </a>
                                    <span className="text-sm leading-6 text-[#65717D]">Document from the 2026 faculty-publication archive</span>
                                </div>
                            </div>
                        </article>
                    </div>
                )}
            </div>
        </section>
    );
}

export { DEFAULT_PUBLICATIONS as facultyPublications2026 };
